import { HTMLAttributes, ReactNode } from 'react';

import { AppLink } from '@adapters';

interface BreadcrumbsItemProps extends HTMLAttributes<HTMLLIElement> {
  href?: string;
  children: ReactNode;
}

const BreadcrumbsItem = ({
  href,
  children,
  ...props
}: BreadcrumbsItemProps) => {
  return (
    <li {...props}>
      {!href ? (
        <>{children}</>
      ) : (
        <AppLink href={href}>{children}</AppLink>
      )}
    </li>
  );
};

export default BreadcrumbsItem;
